module.exports = __webpack_public_path__ + "img/emoji_23.59cf5a70.png";